import * as React from "react";
import Modal from "../../ui/modal/Modal";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import "./jobStatusBulkChangeModal.scss"
import SelectJobStatus from "../statusSelector/SelectJobStatus";
import {none, option, Option} from "ts-option";
import {getLoggedUser} from "../../../store/view/user";
import {UserPermission} from "../../../model/user/UserPermission";
import JobStatus from "../../../model/job/JobStatus";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ConfirmJobStatusChangeModal from "./ConfirmJobStatusChangeModal";
import {api} from "../../../api/api";
import Toast from "../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

export interface BulkChangeJobStatusData {
	id: string,
	referenceNumber: string,
	customer: string,
	status: string
}

interface IComponentProps {
	onCancel: () => void;
	onSuccess: () => void;
	jobsData: BulkChangeJobStatusData[]
}

interface IState {
	processing: boolean,
	status: Option<JobStatus>
	showConfirmation: boolean
}

type Props = IComponentProps;

export default class JobStatusBulkChangeModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			processing: false,
			status: none,
			showConfirmation: false
		};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} oveflowUnset mediumWidth title={"Bulk job status change"}>
				<div className={"c-bulk-change-job-status-modal"}>
					<div className={"c-job-status-selector"}>
						<SelectJobStatus placeholder={"Select status to which below jobs will be changed.."}
										 selectedId={this.state.status.map(s => s.id)}
										 clearable={false}
										 onChanged={this.handleStatusChange}
										 disabled={getLoggedUser().map(
											 user => !user.hasPermissions([UserPermission.JobStatusUpdate])).getOrElse(true)}
						/>
					</div>
					<div className={"jobs-grid"} >
						<Row customClass={"header"}>
							<Col xl={2} md={2}>ID</Col>
							<Col xl={4} md={4}>Customer</Col>
							<Col xl={6} md={6}>Status</Col>
						</Row>
						{this.props.jobsData.map(jd =>
							<Row key={jd.referenceNumber}>
								<Col xl={2} md={2}>{jd.referenceNumber}</Col>
								<Col xl={4} md={4}>{jd.customer}</Col>
								<Col xl={6} md={6}>
									<div className={"status"}>{jd.status}</div>
								</Col>
							</Row>
						)}
					</div>
					<div className={"button-container"}>
						<ButtonTertiary label={"Cancel"} onClick={this.props.onCancel}/>
						<ButtonPrimary variant={"burgundy"}
									   disabled={this.state.status.isEmpty}
									   isLoading={this.state.processing}
									   label={"Change statuses"}
									   onClick={this.showConfirmation}/>
					</div>
				</div>
				{this.state.showConfirmation && this.state.status.map(
					s => <ConfirmJobStatusChangeModal onClose={this.hideConfirmation}
													  onConfirm={this.changeStatuses}
													  status={s}/>).orNull}
			</Modal>
		);
	}

	handleStatusChange = (status: Option<JobStatus>) => {
		this.setState({status})
	};

	showConfirmation = () => {
		this.setState({showConfirmation: true});
	};

	hideConfirmation = () => {
		this.setState({showConfirmation: false});
	};

	changeStatuses = () => {
		this.setState({showConfirmation: false, processing: true}, () => {
			this.state.status.map(s => {
				api.instance.jobApi.updateJobStatuses(this.props.jobsData.map(jd => jd.id), s.id)
					.then(() => {
						this.setState({processing: false}, () => {
							this.props.onSuccess();
							Toast.success("Job statuses was updated successfully",
								"Job statuses update operation success");
						})

					})
					.catch(err => {
						this.setState({processing: false},
							() => notifyBugsnagAndShowToast(err, "Job statuses update operation failed"))
					})
			})

		});
	}
}

